import userRoutes from 'layouts/routes/user'
import adminRoutes from 'layouts/routes/admin'
import adminManajemenTes from 'layouts/routes/adminManajemenTes'

const globalRoutes = [].concat(userRoutes, adminRoutes, adminManajemenTes)

export default globalRoutes
